// extracted by mini-css-extract-plugin
module.exports = {"TopUp":"TopUp_TopUp__3k0s2","Info":"TopUp_Info__Se5vY","CustomVal":"TopUp_CustomVal__1EuRm","topUpBtn":"TopUp_topUpBtn__3lDCb","Procced":"TopUp_Procced__3r6-7"};